import type { RJSFSchema } from '@rjsf/utils';

export enum BuildControlAction {
  DownloadUpdate = 'downloadUpdate',
  RestartApp = 'restartApp',
  OpenDebugMenu = 'openDebugMenu',
}

const buildActionOptions = [
  {
    const: BuildControlAction.DownloadUpdate,
    title: 'Download Update',
    icon: 'SvgDownloadCloud02',
    groupId: 1,
  },
  {
    const: BuildControlAction.RestartApp,
    title: 'Restart App',
    icon: 'RefreshCcw02',
    groupId: 1,
  },
  {
    const: BuildControlAction.OpenDebugMenu,
    title: 'Open Debug Menu',
    icon: 'NoCodeBottomsheet',
    groupId: 1,
  },
];

export const controlBuildSchema: RJSFSchema = {
  type: 'object',
  properties: {
    buildControlAction: {
      type: 'string',
      title: 'Build Action',
      default: BuildControlAction.DownloadUpdate,
      oneOf: [...buildActionOptions],
    },
  },
};

export const controlBuildUISchema = {
  buildControlAction: {
    'ui:title': 'Build Action',
    'ui:widget': 'GroupedSelectWidget',
    'ui:options': {
      'ua:enumIcons': buildActionOptions.map((option) => option.icon),
      'ua:enumGroup': buildActionOptions.map((option) => option.groupId),
    },
  },
};
